module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "TOC"
    }
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "DEDICATION"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/003dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ACKNOWLEDGMENTS"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/004acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "INTRODUCTION"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "COOKINGTIPSANDGUIDELINES"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006introduction#COOKINGTIPSANDGUIDELINES"
    }
  }, [_vm._v("Cooking Tips and Guidelines")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "EQUIPMENTESSENTIALS"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006introduction#EQUIPMENTESSENTIALS"
    }
  }, [_vm._v("Equipment Essentials")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapter1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1"
    }
  }, [_vm._v("Eggs, Eggs, Eggs")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "PoachedEggsAsparagusandChorizo"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#PoachedEggsAsparagusandChorizo"
    }
  }, [_vm._v("Poached Eggs, Asparagus, and Chorizo")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "EggsBenedictwithNewOrleansAccents"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#EggsBenedictwithNewOrleansAccents"
    }
  }, [_vm._v("Eggs Benedict with New Orleans Accents")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "BestEverScrambledEggs"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#BestEverScrambledEggs"
    }
  }, [_vm._v("Best-Ever Scrambled Eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "HerbedScrambledEggsNestledinBroiledPortobellos"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#HerbedScrambledEggsNestledinBroiledPortobellos"
    }
  }, [_vm._v("Herbed Scrambled Eggs Nestled in Broiled Portobellos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "PanFriedEggsandMixedMushroomSautonToastedSourdoughSlices"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#PanFriedEggsandMixedMushroomSautonToastedSourdoughSlices"
    }
  }, [_vm._v("Pan-Fried Eggs and Mixed Mushroom Sauté on Toasted Sourdough Slices")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "EggsBakedwithCrmeFracheCrabandTarragon"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#EggsBakedwithCrmeFracheCrabandTarragon"
    }
  }, [_vm._v("Eggs Baked with Crème Fraîche, Crab, and Tarragon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "PotatoandArugulaOmelets"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#PotatoandArugulaOmelets"
    }
  }, [_vm._v("Potato and Arugula Omelets")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapter2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2"
    }
  }, [_vm._v("All-In-One from the Over")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "GratinofEggsLeeksBaconandStAndrCheese"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#GratinofEggsLeeksBaconandStAndrCheese"
    }
  }, [_vm._v("Gratin of Eggs, Leeks, Bacon, and St. André Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "SouffldEggswithRicottaSpinachandPancetta"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#SouffldEggswithRicottaSpinachandPancetta"
    }
  }, [_vm._v("Souffléd Eggs with Ricotta, Spinach, and Pancetta")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ParmesanFlanswithParmesanCrisps"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#ParmesanFlanswithParmesanCrisps"
    }
  }, [_vm._v("Parmesan Flans with Parmesan Crisps")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "CaramelizedShallotandHamTartlets"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#CaramelizedShallotandHamTartlets"
    }
  }, [_vm._v("Caramelized Shallot and Ham Tartlets")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "GrapeTomatoandBlueCheeseTart"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#GrapeTomatoandBlueCheeseTart"
    }
  }, [_vm._v("Grape Tomato and Blue Cheese Tart")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "SpicyShrimpandGrits"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#SpicyShrimpandGrits"
    }
  }, [_vm._v("Spicy Shrimp and Grits")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapter3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3"
    }
  }, [_vm._v("Hot Off the Griddle")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "MinuteBlini"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#MinuteBlini"
    }
  }, [_vm._v("10-Minute Blini")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "SpicedPancakeswithWarmMapleButterSyrup"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#SpicedPancakeswithWarmMapleButterSyrup"
    }
  }, [_vm._v("Spiced Pancakes with Warm Maple-Butter Syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "LemonRicottaPancakeswithBlueberrySauce"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#LemonRicottaPancakeswithBlueberrySauce"
    }
  }, [_vm._v("Lemon-Ricotta Pancakes with Blueberry Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "GoldenPecanWaffleswithWarmSaltedCaramelSauceandBananas"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#GoldenPecanWaffleswithWarmSaltedCaramelSauceandBananas"
    }
  }, [_vm._v("Golden Pecan Waffles with Warm Salted Caramel Sauce and Bananas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "OrangeWholeWheatWaffleswithYogurtandFreshBerries"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#OrangeWholeWheatWaffleswithYogurtandFreshBerries"
    }
  }, [_vm._v("Orange Whole-Wheat Waffles with Yogurt and Fresh Berries")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "BakedEggnogFrenchToastwithCranberriesandApples"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#BakedEggnogFrenchToastwithCranberriesandApples"
    }
  }, [_vm._v("Baked Eggnog French Toast with Cranberries and Apples")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "StrawberryGlazedFrenchToastwithSweetenedSourCream"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#StrawberryGlazedFrenchToastwithSweetenedSourCream"
    }
  }, [_vm._v("Strawberry-Glazed French Toast with Sweetened Sour Cream")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapter4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4"
    }
  }, [_vm._v("The Bread Basket")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "CranberryPecanScones"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#CranberryPecanScones"
    }
  }, [_vm._v("Cranberry-Pecan Scones")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "LemonDateMuffinswithPecans"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#LemonDateMuffinswithPecans"
    }
  }, [_vm._v("Lemon-Date Muffins with Pecans")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "TwiceGingerGingerbreadMuffins"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#TwiceGingerGingerbreadMuffins"
    }
  }, [_vm._v("Twice-Ginger Gingerbread Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "TartCherryandAlmondMuffins"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#TartCherryandAlmondMuffins"
    }
  }, [_vm._v("Tart Cherry and Almond Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "CloudBiscuits"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#CloudBiscuits"
    }
  }, [_vm._v("Cloud Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "MileHighPopovers"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#MileHighPopovers"
    }
  }, [_vm._v("Mile-High Popovers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "EspressoScentedCoffeeCake"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#EspressoScentedCoffeeCake"
    }
  }, [_vm._v("Espresso-Scented Coffee Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "SausageStuddedCornbread"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#SausageStuddedCornbread"
    }
  }, [_vm._v("Sausage-Studded Cornbread")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapter5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5"
    }
  }, [_vm._v("Fruits for All Seasons")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "DuoofMelonswithHoneyLimeandGinger"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#DuoofMelonswithHoneyLimeandGinger"
    }
  }, [_vm._v("Duo of Melons with Honey, Lime, and Ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "HoneyRoastedPeaches"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#HoneyRoastedPeaches"
    }
  }, [_vm._v("HoneyRoasted Peaches")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "PoachedApricotsandGreekYogurtwithPistachios"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#PoachedApricotsandGreekYogurtwithPistachios"
    }
  }, [_vm._v("Poached Apricots and Greek Yogurt with Pistachios")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "PlumParfaitswithYogurtandGranola"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#PlumParfaitswithYogurtandGranola"
    }
  }, [_vm._v("Plum Parfaits with Yogurt and Granola")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "WarmAppleandDateCompoteswithWhippedMapleCream"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#WarmAppleandDateCompoteswithWhippedMapleCream"
    }
  }, [_vm._v("Warm Apple and Date Compotes with Whipped Maple Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "SummerBerrieswithLemonCrmeFrache"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#SummerBerrieswithLemonCrmeFrache"
    }
  }, [_vm._v("Summer Berries with Lemon Crème Fraîche")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "WineGlazedGrapefruitCups"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#WineGlazedGrapefruitCups"
    }
  }, [_vm._v("Wine-Glazed Grapefruit Cups")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapter6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6"
    }
  }, [_vm._v("Breakfast Complements")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "RoastedTomatoesontheVine"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#RoastedTomatoesontheVine"
    }
  }, [_vm._v("Roasted Tomatoes on the Vine")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "RoastedSweetPotatoHashBrowns"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#RoastedSweetPotatoHashBrowns"
    }
  }, [_vm._v("Roasted Sweet Potato Hash Browns")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "SkilletRoastedPotatoeswithMushroomsandPancetta"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#SkilletRoastedPotatoeswithMushroomsandPancetta"
    }
  }, [_vm._v("Skillet-Roasted Potatoes with Mushrooms and Pancetta")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "SouthernCheeseGrits"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#SouthernCheeseGrits"
    }
  }, [_vm._v("Southern Cheese Grits")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "BaconwithaBrownSugarMustardGlaze"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#BaconwithaBrownSugarMustardGlaze"
    }
  }, [_vm._v("Bacon with a Brown Sugar-Mustard Glaze")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "SmokedSausageandAppleHash"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#SmokedSausageandAppleHash"
    }
  }, [_vm._v("Smoked Sausage and Apple Hash")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "SmokedSalmonFennelandPotatoHash"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#SmokedSalmonFennelandPotatoHash"
    }
  }, [_vm._v("Smoked Salmon, Fennel, and Potato Hash")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "SmokedSalmonwithHerbedCrmeFrache"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#SmokedSalmonwithHerbedCrmeFrache"
    }
  }, [_vm._v("Smoked Salmon with Herbed Crème Fraîche")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "HeavenlyLittleCrabCakes"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#HeavenlyLittleCrabCakes"
    }
  }, [_vm._v("Heavenly Little Crab Cakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapter7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7"
    }
  }, [_vm._v("Drinks, Classic and New")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "FreshCitrusSpritzers"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#FreshCitrusSpritzers"
    }
  }, [_vm._v("Fresh Citrus Spritzers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ChampagneTwoWays"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#ChampagneTwoWays"
    }
  }, [_vm._v("Champagne Two Ways")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ClassicMimosas"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#ClassicMimosas"
    }
  }, [_vm._v("Classic Mimosas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "Bellinis"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#Bellinis"
    }
  }, [_vm._v("Bellinis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "BloodyMarys"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#BloodyMarys"
    }
  }, [_vm._v("Bloody Marys")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "WarmFallCiderwithSpices"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#WarmFallCiderwithSpices"
    }
  }, [_vm._v("Warm Fall Cider with Spices")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "IrishCoffee"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#IrishCoffee"
    }
  }, [_vm._v("Irish Coffee")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "THEBRUNCHPLANNER"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014thebrunchplanner"
    }
  }, [_vm._v("The Brunch Planner")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "INDEX"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015index"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/016abouttheauthor"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/017copyright"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33e955eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005-toc.vue
// module id = 69
// module chunks = 0